module.exports = __webpack_public_path__ + "img/4576be7.jpg";